/**
 * Auto-generated screenshot mapping
 * Generated on: 2025-09-16T02:39:37.362Z
 * 
 * This file is automatically generated by scripts/generate-screenshot-mapping.js
 * Do not edit this file manually - run the script instead!
 */

interface ScreenshotProject {
  type: 'mobile' | 'web';
  files: string[];
}

interface ScreenshotsMapping {
  [projectId: string]: ScreenshotProject;
}

export const autoGeneratedScreenshots: ScreenshotsMapping = {
  "gesture-smart": {
    "type": "mobile",
    "files": [
      "IMG-20250806-WA0012.jpg",
      "IMG-20250806-WA0013.jpg",
      "IMG-20250806-WA0014.jpg",
      "IMG-20250806-WA0015.jpg",
      "IMG-20250806-WA0016.jpg",
      "IMG-20250806-WA0017.jpg",
      "IMG-20250806-WA0018.jpg",
      "IMG-20250806-WA0019.jpg",
      "IMG-20250806-WA0020.jpg",
      "IMG-20250806-WA0021.jpg",
      "IMG-20250806-WA0022.jpg",
      "IMG-20250806-WA0023.jpg",
      "IMG-20250806-WA0024.jpg",
      "IMG-20250806-WA0025.jpg",
      "IMG-20250806-WA0026.jpg",
      "IMG-20250806-WA0027.jpg",
      "IMG-20250806-WA0028.jpg",
      "IMG-20250806-WA0029.jpg",
      "IMG-20250806-WA0030.jpg",
      "IMG-20250806-WA0031.jpg",
      "IMG-20250806-WA0032.jpg"
    ]
  },
  "invoice-manager": {
    "type": "web",
    "files": [
      "clients.png",
      "dashboard.png",
      "invoices.png",
      "main.png",
      "plans.png",
      "products.png",
      "profile.png",
      "themes.png"
    ]
  }
};

/**
 * Get screenshots for a project
 */
export const getScreenshotsForProject = (projectId: string, type: 'mobile' | 'web'): string[] => {
  const project = autoGeneratedScreenshots[projectId];
  
  if (!project || project.type !== type) {
    // console.warn(`No screenshots found for project: ${projectId} (type: ${type})`);
    return [];
  }
  
  const basePath = type === 'mobile' ? '/mobile-apps' : '/websites';
  return project.files.map((file: string) => `${basePath}/${projectId}/screenshots/${file}`);
};

/**
 * Get all projects with screenshots
 */
export const getProjectsWithScreenshots = (): string[] => {
  return Object.keys(autoGeneratedScreenshots);
};

/**
 * Check if a project has screenshots
 */
export const hasScreenshots = (projectId: string): boolean => {
  return projectId in autoGeneratedScreenshots;
};
